import SeoPage from "../components/SeoPage";

export default function MernStack() {
  return (
    <SeoPage
      title="MERN Stack Development Company | Arviko"
      description="Expert MERN stack developers building scalable applications."
      heading="MERN Stack Development Company"
    >
      <p>
        Our team specializes in MongoDB, Express, React, and Node.js development.
      </p>
    </SeoPage>
  );
}